import React, { useState, useContext, useEffect } from "react";
import { Input, Row, Col } from "design-react-kit";
import moment from "moment";

function InterventoFamiglieAffidatarieComponent({
  handleChange,
  formData,
  iban,
  componenteNucleoFamiliare,
}) {
  const handleCheck = (id) => {
    if (formData?.componentiNucleoFamiliareIds?.includes(id)) {
      handleChange({
        target: {
          name: "componentiNucleoFamiliareIds",
          value: formData.componentiNucleoFamiliareIds.filter((x) => x !== id),
        },
      });
    } else {
      handleChange({
        target: {
          name: "componentiNucleoFamiliareIds",
          value: [...formData.componentiNucleoFamiliareIds, id],
        },
      });
    }
  };

  return (
    <>
      <div className="pt-3 px-5 mx-5">
        {!iban && (
          <Input
            id="iban"
            name="iban"
            label="IBAN*"
            value={formData?.iban || ""}
            onChange={handleChange}
          />
        )}
        {componenteNucleoFamiliare?.length === 0 && (
          <div className="alert alert-warning">
            Nessun <b>minore</b> disponibile nel nucleo familiare.
          </div>
        )}
      </div>
      <b>Selezionare il minore o i minori coinvolti:</b>
      {componenteNucleoFamiliare?.map((c) => (
        <div className="text-left">
          <div className="d-flex flex-wrap pt-3 px-5 mx-5">
            <label key={c.id} className="mr-4 mb-2" style={{ minWidth: 220 }}>
              <input
                type="checkbox"
                checked={formData?.componentiNucleoFamiliareIds?.includes(c.id)}
                onChange={() => handleCheck(c.id)}
              />{" "}
              {c.nome} {c.cognome} (
              {c.relazioneConAssistito ? c.relazioneConAssistito + ", " : ""}
              {c.dataNascita}, {c.codiceFiscale})
            </label>
          </div>
        </div>
      ))}
    </>
  );
}

export default InterventoFamiglieAffidatarieComponent;
